import { initialize } from "./initialize";
import { interaction } from "./interaction";
import { standard } from "./standard";
import { NewRelicConfig } from "@coxauto-ui/core-models-third-party-newrelic";

export type { NewRelicConfig };
export const NewRelic = {
  initialize,
  interaction,
  ...standard
};
